import { useCallback } from 'react';
import throttle from 'lodash.throttle';

export default function useThrottleCallback(cb: () => void, deps: Array<any> = [], ms: number = 100): () => void {
  return useCallback(throttle(cb, ms), deps);
}
